export default __webpack_public_path__ + "static/media/calendar.192b1371.svg";